<template>
  <div class="navbar__cart" :class="sidecartOpen ? 'open' : ''">
    <cart-modal>
      <v-button
        label="Open Cart"
        @click="$store.dispatch('cart/openSidecart')"
        aria-label="Open Cart"
      >
        <icon name="cart" size="24px"></icon>
        <span
          class="cart-bubble-quantity navbar__cart__quantity"
          v-if="numCartItems > 0"
          :class="cartBubbleColors.bubbleBg"
        >
          <span
            class="cart-bubble-count navbar__cart__count"
            :class="[
              cartBubbleColors.bubbleText,
              { 'cart-bubble-count--small': numCartItems >= 100 }
            ]"
            >{{ displayItemCount }}</span
          >
        </span>
      </v-button>
    </cart-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import VButton from '@/scripts/components/buttons/VButton.vue'
import Icon from '@/scripts/components/basic/Icon.vue'
import CartModal from '@/scripts/components/cart/CartModal.vue'

export default {
  name: 'NavbarCart',
  components: { VButton, Icon, CartModal },
  props: {
    cartBubbleColors: Object
  },
  computed: {
    ...mapState({
      checkout: state => state.cart.checkout,
      sidecartOpen: state => state.cart.sidecartOpen
    }),
    numCartItems () {
      return this.checkout.item_count || 0
    },
    displayItemCount () {
      return this.numCartItems < 100 ? this.numCartItems : '99+'
    }
  }
}
</script>

<style scoped lang="scss">
.navbar__cart {
  position: relative;
  margin-right: 12px;
  opacity: 1;
  transition: opacity 100ms ease;

  @include desktop-up {
    margin-right: 0;
  }
}

.navbar__cart .button--icon {
  border: 0;
  min-width: 24px;
  height: 40px;
}
.open {
  opacity: 0;
}
</style>
